import { useEffect, useState } from 'react';

/** The Dabbeh state lives in localStorage: render it only after mount so SSR and hydration agree. */
export const useMounted = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted;
};
